jQuery(document).ready(function( $ ) {

	//variables used
	const $header = $('.site-header');
	const $sidenav = $('.sidenav');
	let $headerHeight;

	function menuToggle() {
		// make menu sticky on toogle
		$header.addClass('sticky-nav');
		$headerHeight = $header.outerHeight(true);
        $('#scroll-gap-fix').css('margin-top', $headerHeight);
		$sidenav.css('top', $headerHeight);
		// Toggle the Slidebar
		$('.sidenav').toggleClass('sidenav-expanded');
		$('body').toggleClass('slide-right');

	}

	// call function on windows resize
	$(window).on('resize', function(){
		$headerHeight = $header.outerHeight(true);
		$sidenav.css('top', $headerHeight);
	}).trigger('resize');

	//toggle main menu on buttom menu or X button
	$(".menu-toggle").on("click", function(e) {
		// Stop default action and bubbling
		e.stopPropagation();
		e.preventDefault();
		menuToggle();
	});

	//hide menu if clicked outside of it
	$(document).click(function(e) {
		let $clicked = $(e.target);
		if ( $('.sidenav').hasClass('sidenav-expanded')
			&& !$clicked.parents().hasClass("sidenav-main")
			&& !$clicked.hasClass("sidenav")
		) {
			menuToggle();
		}
	});

	// hide sidenav menu if esc key is pressed
	document.addEventListener('keyup', function (event) {
		if ( event.defaultPrevented || !$('.sidenav').hasClass('sidenav-expanded') ) {
			return;
		}
		let key = event.key || event.keyCode;
		if (key === 'Escape' || key === 'Esc' || key === 27) {
			menuToggle();
		}
	});

	//show submenu on click
	$(".dropdown").on("click", function(e) {
		e.stopPropagation();
		e.preventDefault();
		$(this).toggleClass('dropdown-active');
		$(this).parent().parent().find('ul.sub-menu').first().toggleClass('sub-menu-expanded');
	});


	$(window).scroll(function checkScroll() {

		if( $('body').hasClass('slide-right') ){
			return;
		}

		if( $(window).scrollTop() > 0 ) {
			$header.addClass('sticky-nav');
			$('#scroll-gap-fix').css('margin-top', $headerHeight);
		} else {
			$header.removeClass('sticky-nav');
			$('#scroll-gap-fix').css('margin-top', 0);
		}

	}).trigger('checkScroll');


	// fix anchor links positioning
	$(function () {
		$('a[href*=\\#]:not([href=\\#])').click(function () {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&& location.hostname == this.hostname) {

				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html,body').animate({
						scrollTop: target.offset().top + 20 //offsets for fixed header
					}, 1000);
					return false;
				}
			}
		});
		//Executed on page load with URL containing an anchor tag.
		if ($(location.href.split("#")[1])) {
			var target = $('#' + location.href.split("#")[1]);
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top - $headerHeight //offset height of header here too.
				}, 1000);
				return false;
			}
		}
	});


});
